// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"Avatar_avatarWrapper__K9T-K","Avatar":"Avatar_Avatar__NYdVe","round":"Avatar_round__N30Yc","noImage":"Avatar_noImage__voymE"};